import React, {useState, useEffect} from "react";
import {Button, Modal, Upload, Spin, Form, notification, Row, Col} from "antd";
import RadioField from "../../radio-field";
import DividerBlock from "../../divider-block";
import FieldBlock from "../../field-block";
import {formHelper} from "../../../helpers";
import '../modals.css';
import i18n from "i18next";
import {legalEntityService} from '../../../services/legal-entity.service';

export default function ModalEditLegalEntityGosLog({isShow, setIsShow, legalEntityId, legalEntityName, setIsNeedUpdate}) {

  const [loading, setLoading] = useState(true);
  const [fieldsErrors, setFieldsErrors] = useState({});
  const [gosLogValue, setGosLogValue] = useState(null);
  const [isDisabled, setIsDisabled] = useState(true);
  const [docFields, setFields] = useState({});
  const [docsList, setDocsList] = useState(null);
  const [errors, setError] = useState({});

  const [gosLogOptions] = useState([
    {
      Id: "3",
      Name: i18n.t('main.yes')
    },
    {
      Id: "2",
      Name: i18n.t('main.no')
    }
  ]);

  let dividerStyle = {
    margin: '15px 0px 45px 0px',
    display: "block",
    clear: "both",
    width: "100%",
    minWidth: "100%",
    height: "1px"
  }

  const getUploaderClass = (name) => {
    return {
      multiple: true,
      showUploadList: true,
      onRemove: (file) => {
        docFields[name].forEach((stepFile, index) => {
          if (stepFile.uid === file.uid) {
            docFields[name].splice(index, 1);
          }
          setFields({...docFields, [name]: docFields[name]});
        });
      },
      beforeUpload: (file, fileList) => {
        if (file.type === "application/pdf") {
          file.thumbUrl =
            "https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg";
        } else {
          file.url = URL.createObjectURL(
            file instanceof File
              ? file
              : formHelper.b64toBlob(file, "image/png")
          );
        }

        let isCorrectFiles = formHelper.checkFiles(fileList, docFields[name], setError, errors, name);

        if (isCorrectFiles) {
          setError({...errors, [name]: ''});

          if (docFields[name]) {
            setFields({
              ...docFields,
              [name]: docFields[name].concat(fileList),
            });
          } else {
            setFields({...docFields, [name]: fileList});
          }
        }

        return false;
      },
      listType: 'picture',
    };
  };

  useEffect(() => {
    if (isShow) {
      setGosLogValue(null);
      setFields({});
      setError({});
      setFieldsErrors({});
      setDocsList(null);
      setLoading(false);
    }
  }, [isShow]);

  useEffect(() => {
    if (gosLogValue !== null) {
      if (gosLogValue === "1" && !docFields.documentGosLog) {
        setIsDisabled(true);
      } else {
        setIsDisabled(false);
      }
    } else {
      setIsDisabled(true);
    }
    setDocsList(null);
  }, [gosLogValue, docFields]);

  const getFieldErrors = (fieldName) => {
    return typeof fieldsErrors[fieldName] !== "undefined"
      ? fieldsErrors[fieldName].reduce((fieldErrors, error) => {
        return fieldErrors + "; " + error;
      })
      : null;
  };

  let bigButtonStyle = {
    width: '190px',
    height: '40px',
    background: '#1CAA53',
    position: 'static',
    borderRadius: '10px',
    borderColor: "#1CAA53"
  };

  const textStyle = {
    textAlign: 'center',
    color: 'black'
  };

  const DownloadIcon = () => {
    return <svg width="17" height="22" viewBox="0 0 17 22" fill="none" xmlns="http://www.w3.org/2000/svg"
                className="download-file-svg">
      <path
        d="M11.5631 0.165835C11.4647 0.0622087 11.3298 0 11.19 0H2.81953C1.27495 0 0 1.26988 0 2.81429V18.643C0 20.1875 1.27495 21.4574 2.81953 21.4574H14.1805C15.725 21.4574 17 20.1875 17 18.643V6.07435C17 5.93962 16.9378 5.81013 16.8497 5.71158L11.5631 0.165835ZM11.7134 1.82959L15.2534 5.54574H12.9522C12.268 5.54574 11.7134 4.99634 11.7134 4.31221V1.82959ZM14.1805 20.4208H2.81953C1.85038 20.4208 1.03659 19.6175 1.03659 18.643V2.81429C1.03659 1.84514 1.84514 1.03659 2.81953 1.03659H10.6768V4.31221C10.6768 5.57161 11.6928 6.58233 12.9522 6.58233H15.9634V18.643C15.9634 19.6175 15.1549 20.4208 14.1805 20.4208Z"
        fill="#1CAA53"></path>
      <path
        d="M12.7642 16.8447H4.23314C3.94813 16.8447 3.71484 17.0778 3.71484 17.363C3.71484 17.648 3.94813 17.8813 4.23314 17.8813H12.7695C13.0545 17.8813 13.2878 17.648 13.2878 17.363C13.2878 17.0778 13.0545 16.8447 12.7642 16.8447Z"
        fill="#1CAA53"></path>
      <path
        d="M5.84741 11.268L7.9828 8.97187V14.6317C7.9828 14.9167 8.21608 15.15 8.5011 15.15C8.78627 15.15 9.01939 14.9167 9.01939 14.6317V8.97187L11.1548 11.268C11.2584 11.3767 11.3933 11.4339 11.5331 11.4339C11.6575 11.4339 11.7872 11.3872 11.8856 11.2939C12.093 11.097 12.1085 10.7704 11.9116 10.5631L8.87435 7.30304C8.7758 7.19942 8.64107 7.13721 8.49602 7.13721C8.35081 7.13721 8.21608 7.19942 8.11769 7.30304L5.08044 10.5631C4.8835 10.7704 4.89906 11.102 5.10631 11.2939C5.32404 11.4908 5.65047 11.4753 5.84741 11.268Z"
        fill="#1CAA53"></path>
    </svg>
  }

  const DownloadField = ({doc, index}) => {

    const getFilesErrors = () => {
      const afterSubmitErrors = getFieldErrors(doc.requestName);
      return errors[doc.requestName] ?
        errors[doc.requestName] :
        afterSubmitErrors ? afterSubmitErrors : '';
    }

    return <>
      <Col lg={12} md={24} sm={24} xs={24} key={`${index + 1}-doc-legal-entity`}>
        <FieldBlock name={doc.requestName}
                    getErrors={getFilesErrors}>
          <Upload defaultFileList={docFields[doc.requestName]}
                  fileList={docFields[doc.requestName]}
                  className="single-btn-upload" {...getUploaderClass(doc.requestName)}>
            <Button style={{textAlign: "left"}} htmlType="button">
              <DownloadIcon/>
              {doc.description}
            </Button>
          </Upload>
        </FieldBlock>
      </Col>
    </>
  }

  const onSubmitForm = () => {
    setIsDisabled(true);
    legalEntityService.changeLegalEntityGosLog(legalEntityId, gosLogValue, docFields)
      .then((response) => {

        if (response.code === 400) {
          notification.error({
            message: i18n.t('Обновление статуса регистрации в Гос.Лог'),
            description: response.message,
          });
          setFieldsErrors(response.errors);
        } else {
          if (response.status === 'success') {
            notification.success({
              message: i18n.t('Обновление статуса регистрации в Гос.Лог'),
              description: response.message,
            });
            setIsShow(false);
            setIsNeedUpdate(true);
          } else {
            if (response instanceof Object) {
              setDocsList(Object.values(response));
            } else {
              setDocsList(response);
            }
          }
        }
      })
      .catch((err) => {
        notification.error({
          message: i18n.t('Обновление статуса регистрации в Гос.Лог'), description: err,
        });
      })
      .finally(() => {
        setIsDisabled(false);
      })
  }

  return (
    <Modal
      title={<span className="ant-modal-title">{i18n.t('Статус регистрации в Гос.Лог')}</span>}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      style={{maxWidth: '450px'}}
      align={null}
      visible={isShow}
      onCancel={() => {
        setIsShow(false);
        setIsNeedUpdate(true);
      }}
      footer={[
        <Button htmlType="submit"
                style={bigButtonStyle}
                key="submit"
                type="primary"
                onClick={() => onSubmitForm()}
                disabled={isDisabled}
        >{i18n.t('main.buttons.save')}</Button>,
      ]}
    >
      <Spin spinning={loading} tip={i18n.t('main.loadText.loading')}>
        <Form>
          <Row>
            <p>{i18n.t('Вступаете ли Вы в реестр уведомлений о транспортно экспедиционной деятельности в соответствии с Федеральным законом от 07.06.2025 № 140 ФЗ «О внесении изменений в Федеральный закон «О транспортно экспедиционной деятельности» и отдельные законодательные акты Российской Федерации» с 01.03.2026?')}</p>
          </Row>
          <DividerBlock/>
          <Row>
            <h2 style={textStyle}>{i18n.t('Юр. лицо')}: {legalEntityName}</h2>
          </Row>
          <Row>
            <Col>
              <RadioField
                title={i18n.t('Статус регистрации')}
                values={gosLogOptions}
                onChange={(value) => setGosLogValue(value.target.value)}
                selectedValue={gosLogValue}
                getErrors={getFieldErrors}
              />
            </Col>
          </Row>
          <Row>
            <p>{i18n.t('Если вы не загрузите документы о регистрации в Гос.Лог, то с 1.05.2026 вы не сможете работать с рейсами ГК Витал.')}</p>
          </Row>
          {gosLogValue === "3" && <Row gutter={[12, 24]} style={{marginTop: '20px'}}>
            <Col lg={12} md={24} sm={24} xs={24}>
              <FieldBlock name="documentGosLog"
                          getErrors={() => errors.documentGosLog ? errors.documentGosLog : getFieldErrors('documentGosLog')}>
                <Upload defaultFileList={docFields.documentGosLog}
                        fileList={docFields.documentGosLog}
                        className="single-btn-upload" {...getUploaderClass('documentGosLog')}>
                  <Button style={{textAlign: "left"}} htmlType="button">
                    <DownloadIcon/>
                    Документ Гос.Лог
                  </Button>
                </Upload>
              </FieldBlock>
            </Col>
          </Row>}

          {docsList && <Row gutter={[12, 24]} style={{marginTop: '20px'}}>
            <span className="divider-label">{i18n.t('modals.modalEditLegalEntityTax.divider.scanDocs')}</span>
            <DividerBlock style={dividerStyle}/>
            {docsList.map((doc, index) =>
              <DownloadField doc={doc} index={index} key={index + 1}/>
            )}
          </Row>}

        </Form>
      </Spin>
    </Modal>
  );
}